import { useGetPaymentsStats } from '../../hooks/use-get-payments-stats';
import { PaymentsStatsFilter } from './payments-stats-filter';
import { PaymentsStatsContent } from './payments-stats-content';

export const PaymentsStats = () => {
  const {
    data,
    isLoading,
    handleFilterChange,
    handleFilterReset,
  } = useGetPaymentsStats();

  return (
    <>
      <PaymentsStatsFilter
        onSubmit={handleFilterChange}
        onReset={handleFilterReset}
      />

      <PaymentsStatsContent
        data={data}
        isLoading={isLoading}
      />
    </>
  );
};
